import {cn} from '@purpose/ui/lib/utils';

type DividerProps = React.HTMLAttributes<HTMLDivElement>;

const Divider = ({className, ...props}: DividerProps) => {
  return (
    <div className={cn('bg-secondary-10 h-px w-full', className)} {...props} />
  );
};

export default Divider;
